// action types
const TYPES = {
	SYSTEM_INFO: 'SYSTEM_INFO', //系统信息
	REQUEST_INFO: 'REQUEST_INFO', //临时请求数组
	SET_SYS_INFO: 'SET_SYS_INFO', //公告信息
	SET_GPS: 'SET_GPS', //用户定位
	CLIENT: 'CLIENT', //
	SET_THEME: 'SET_THEME', //主题
	SET_DDNS: 'SET_DDNS', //域名
};

// initial state
const state = {
	systemInfo: {},
	requestInfo: {},
	sysInfo: {}, //公告类
	Gps: '',
	client: '',
	theme: 'day',
	DDNS: {},
	httpImg: '',
};

// getters
const getters = {};

// actions
const actions = {
	client({
		commit
	}, data = {}) {
		commit(TYPES.CLIENT, data)
	},
	systemInfo({
		commit
	}, systemInfo = {}) {
		//判断是否是带下划线的苹果
		if (systemInfo.model.search('iPhone 11') == 0 || systemInfo.model.search('iPhone X') == 0) {
			systemInfo.sysSort = true;
		} else {
			systemInfo.sysSort = false;
		}
		//判断定阅消息兼容
		let sdk = compareVersion(systemInfo.SDKVersion, '2.8.3');
		systemInfo.SDKVersionNewest = compareVersion(systemInfo.SDKVersion, '2.10.1'); //查询是否支持查询静默
		systemInfo.SDKVersionTrue = sdk; //查询
		if (systemInfo.platform == 'ios') {
			systemInfo.versionTrue = compareVersion(systemInfo.version, '7.0.6') && sdk ? 1 : 0;
		} else {
			systemInfo.versionTrue = compareVersion(systemInfo.version, '7.0.7') && sdk ? 1 : 0;
		}
		commit(TYPES.SYSTEM_INFO, systemInfo);
	},
	requestInfo({
		commit
	}, requestInfo = {}) {
		commit(TYPES.REQUEST_INFO, requestInfo)
	},
	setSysInfo({
		commit
	}, data = {}) {
		commit(TYPES.SET_SYS_INFO, data)
	},
	setGps({
		commit
	}, data = {}) {
		commit(TYPES.SET_GPS, data)
	},
	setTheme({
		commit
	}, data = {}) {
		commit(TYPES.SET_THEME, data)
	},
	setDDNS({
		commit
	}, data = {}) {
		commit(TYPES.SET_DDNS, data)
	},
};

// mutations
const mutations = {
	[TYPES.SYSTEM_INFO](state, systemInfo) {
		state.systemInfo = systemInfo
	},
	//请求信息
	[TYPES.REQUEST_INFO](state, requestInfo) {
		if (requestInfo.token) {
			state.requestInfo.token = requestInfo.token
		}
		if (requestInfo.uid) {
			state.requestInfo.uid = requestInfo.uid
		}
		if (requestInfo.scene) {
			state.requestInfo.scene = requestInfo.scene
		}
		if (requestInfo.code) {
			state.requestInfo.code = requestInfo.code
		}
		if (requestInfo.openid) {
			state.requestInfo.openid = requestInfo.openid
		}
	},
	[TYPES.SET_SYS_INFO](state, data) {
		state.sysInfo = data
	},
	[TYPES.SET_GPS](state, data) {
		state.Gps = data
	},
	[TYPES.CLIENT](state, data) {
		state.client = data
	},
	[TYPES.SET_THEME](state, data) {
		state.theme = data.theme
	},
	[TYPES.SET_DDNS](state, data) {
		state.DDNS = data.DDNS
		state.httpImg = data.httpImg
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};


// 版本对比
function compareVersion(v1, v2) {
	v1 = v1.split('.')
	v2 = v2.split('.')
	const len = Math.max(v1.length, v2.length)

	while (v1.length < len) {
		v1.push('0')
	}
	while (v2.length < len) {
		v2.push('0')
	}

	for (let i = 0; i < len; i++) {
		const num1 = parseInt(v1[i])
		const num2 = parseInt(v2[i])
		if (num1 > num2) {
			return 1
		} else if (num1 < num2) {
			return 0
		}
	}
	return 0
}